export enum roles {
  SPOWNER = "SP_OWNER",
  SPPARTNER = "SP_PARTNER",
  SPCLIENT = "SP_CLIENT",
  TDCLIENT = "TD_CLIENT",
  TDADMIN = "TD_ADMIN",
}

export enum DashboardAccessLevel {
  Analytics = "ANALYTICS",
  Savings = "SAVING",
  Compliance = "COMPLIANCE",
}

export enum DocumentAccessLevel {
  ViewOnly = "VIEW_ONLY",
  Admin = "ADMIN",
}

export enum ReportAccessLevel {
  Sales = "SALES",
  Performance = "PERFORMANCE",
  Audit = "AUDIT",
}
